module.exports = __webpack_public_path__ + "img/pizza-3.7a0dc458.jpg";